import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCbrWBWUD8rWN38zgo9uh_ahiAPw1eBwD8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "prjctmay-9ee11.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "prjctmay-9ee11",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "prjctmay-9ee11.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "598291660225",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:598291660225:web:a5e96f86e7ddd148c0c340",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-9QNQQDYECW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firestore with settings for better persistence
const db = getFirestore(app);

// Enable offline persistence
const initializeFirestorePersistence = async () => {
  try {
    await enableIndexedDbPersistence(db, {
      cacheSizeBytes: CACHE_SIZE_UNLIMITED
    });
    console.log('✅ Firestore persistence initialized successfully');
  } catch (error) {
    console.error('❌ Error enabling Firestore persistence:', error);
    if (error.code === 'failed-precondition') {
      console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time.');
    } else if (error.code === 'unimplemented') {
      console.warn('The current browser does not support all of the features required to enable persistence');
    }
  }
};

// Call the function to initialize persistence
initializeFirestorePersistence();

const auth = getAuth(app);
const storage = getStorage(app);

// Define the logo image path in storage for consistent reference
export const APP_LOGO_STORAGE_PATH = 'app_logo/logo.png';

console.log('Firebase initialization complete');

export { db, auth, storage, analytics };